module.exports = __webpack_public_path__ + "static/media/gallery14.af000858.jpg";